var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.374,
    height: 16.428,
    viewBox: "0 0 14.374 16.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "trash-alt",
    d: "M1.027,14.888a1.54,1.54,0,0,0,1.54,1.54h9.241a1.54,1.54,0,0,0,1.54-1.54V4.107H1.027ZM9.754,6.674a.513.513,0,0,1,1.027,0v7.187a.513.513,0,1,1-1.027,0Zm-3.08,0a.513.513,0,0,1,1.027,0v7.187a.513.513,0,1,1-1.027,0Zm-3.08,0a.513.513,0,0,1,1.027,0v7.187a.513.513,0,1,1-1.027,0ZM13.861,1.027h-3.85l-.3-.6A.77.77,0,0,0,9.019,0H5.352a.761.761,0,0,0-.687.427l-.3.6H.513A.513.513,0,0,0,0,1.54V2.567a.513.513,0,0,0,.513.513H13.861a.513.513,0,0,0,.513-.513V1.54A.513.513,0,0,0,13.861,1.027Z",
    transform: "translate(0 0)",
    fill: "#db262b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.5725f44f59740838bb5e62444bbb2aeb.svg";
export { ForwardRef as ReactComponent };